export default __webpack_public_path__ + "static/media/priestofmitra_color.42ecdec5.png";